// fade-in animation
$(function () {
  $(window).on('scroll', function () {
    $('.js-fadein, .js-reveal').each(function () {
      const $this = $(this);
      const offsetTop = $this.offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (scrollTop > offsetTop - windowHeight + 150) {
        if (!$this.hasClass('is-animated')) {
          $this.addClass('is-animated is-show');

          $this.find('.fadein-delay, .fadein-none-delay, .fadein-left-delay, .fadein-right-delay, .reveal-left-delay').each(function () {
            const $el = $(this);
            const delay = $el.data('delay') || 0;

            setTimeout(() => {
              $el.addClass('is-show');
            }, delay);
          });

          $this.find('.reveal-down-delay').each(function () {
            const $el = $(this);
            const delay = $el.data('delay') || 0;
            setTimeout(() => { $el.addClass('is-show'); }, delay);
          });
        }
      }
    });
  }).trigger('scroll');
});

// drawer menu open/close
(() => {
  const btn = document.querySelector('.drawer');
  const menu = document.querySelector('.drawer__menu');
  if (!btn || !menu) return;

  const html = document.documentElement;
  let scrollTop = 0;
  const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const onPanelOpened = (e) => {
    if (e.propertyName !== 'transform') return;
    html.classList.add('is-menu-ready');
    menu.removeEventListener('transitionend', onPanelOpened);
  };

  const open = () => {
    btn.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    html.classList.add('is-drawer-open');
    html.classList.remove('is-menu-ready');

    scrollTop = window.pageYOffset;
    html.style.top = `-${scrollTop}px`;
    html.classList.add('no-scroll');

    if (prefersReduce.matches) {
      html.classList.add('is-menu-ready');
    } else {
      menu.addEventListener('transitionend', onPanelOpened);
    }
  };

  const close = () => {
    btn.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');

    html.classList.remove('is-menu-ready');
    html.classList.remove('is-drawer-open');

    html.classList.remove('no-scroll');
    html.style.top = '';
    window.scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
  };

  window.closeDrawer = close;

  const toggle = () => (btn.getAttribute('aria-expanded') === 'true' ? close() : open());

  btn.addEventListener('click', (e) => { e.preventDefault(); toggle(); });

  menu.addEventListener('click', (e) => {
    const t = e.target;
    if (t instanceof Element && t.closest('.drawer__link')) close();
  });

  document.addEventListener('click', (e) => {
    if (btn.getAttribute('aria-expanded') !== 'true') return;
    const target = e.target;
    if (target instanceof Element && !target.closest('.drawer__menu') && !target.closest('.drawer')) {
      close();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
      e.preventDefault();
      close();
    }
  });
})();

// smooth scroll
(() => {
  const OFFSET_RATIO = 0.15; // 画面高の15%上マージン
  const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getOffset = (el) => {
    const ov = el?.getAttribute?.('data-scroll-offset');
    if (ov && !isNaN(parseInt(ov, 10))) return parseInt(ov, 10);
    return Math.round(window.innerHeight * OFFSET_RATIO);
  };

  const scrollToEl = (el) => {
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const y = window.pageYOffset + rect.top - getOffset(el);

    window.scrollTo({
      top: Math.max(y, 0),
      left: 0,
      behavior: prefersReduce.matches ? 'auto' : 'smooth'
    });

    el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: true });
    setTimeout(() => el.removeAttribute('tabindex'), 800);
  };

  const isSamePageHash = (a) => {
    if (!a.hash || a.hash === '#') return false;
    const url = new URL(a.href, location.href);
    return url.origin === location.origin && url.pathname === location.pathname;
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"], a[href*="#"]');
    if (!a || !isSamePageHash(a)) return;

    const id = a.hash.slice(1);
    const target = document.getElementById(id) || document.querySelector(a.hash);
    if (!target) return;

    e.preventDefault();

    const html = document.documentElement;
    const isOpen = html.classList.contains('is-drawer-open');
    const delay = isOpen ? 360 : 0;

    if (isOpen) {
      if (typeof window.closeDrawer === 'function') {
        window.closeDrawer();
      } else {
        html.classList.remove('is-drawer-open', 'no-scroll');
        html.style.top = '';
      }
    }

    setTimeout(() => {
      scrollToEl(target);
      history.pushState(null, '', `#${id}`);
    }, delay);
  });

  window.addEventListener('load', () => {
    if (!location.hash) return;
    const target = document.getElementById(location.hash.slice(1)) || document.querySelector(location.hash);
    if (!target) return;
    setTimeout(() => scrollToEl(target), 0);
  });
})();